import { VStack } from '@terra/ui-styled-system';
import { TimelineStep } from './TimelineStep';
import type {
  TimelineStepData,
  TimelineTimestampPlacement,
  TimelineDetailRenderer,
} from './types';

type TimelineRootProps<TDetailData = unknown> = {
  steps: TimelineStepData<TDetailData>[];
  dateFormatter?: {
    format: (date: Date) => string;
  };
  timestampPlacement?: TimelineTimestampPlacement;
  showOutsideTimestamp?: boolean;
  stepCollapsible?: boolean;
  detailRenderer?: TimelineDetailRenderer<TDetailData>;
};

export const TimelineRoot = <TDetailData,>({
  steps,
  dateFormatter,
  timestampPlacement = 'inside',
  showOutsideTimestamp = true,
  stepCollapsible = false,
  detailRenderer,
}: TimelineRootProps<TDetailData>) => {
  if (steps.length === 0) {
    return null;
  }

  const isLastStep = (index: number) => index === steps.length - 1;

  return (
    <VStack gap={0} alignItems="stretch" w="full">
      {steps.map((step, index) => {
        return (
          <TimelineStep
            key={step.id ?? index}
            step={step}
            hideConnector={isLastStep(index)}
            dateFormatter={dateFormatter}
            timestampPlacement={timestampPlacement}
            showOutsideTimestamp={showOutsideTimestamp}
            stepCollapsible={stepCollapsible}
            detailRenderer={detailRenderer}
          />
        );
      })}
    </VStack>
  );
};
